import React from 'react';
import { Slider, ItemCollection } from '@/components/compendium';
import { CmsPageContentIdentifier, CmsPageContentType, ReduxStateType, Feature,} from '@/types/av-check';
import {connect} from "react-redux";
export interface StateProps {
    cmsContent: CmsPageContentType,
    enabledFeatures: Feature[],
}
type TariffCatalogWrapperProps = {
    slider: boolean,
    isCmsCall: boolean,
    children: any
};
const defaultSliderColumns = 4;
const TariffCatalogWrapper = ({
                                  cmsContent,
                                  slider=false,
                                  children,
                                  enabledFeatures,
                                  isCmsCall,
                              }: StateProps & TariffCatalogWrapperProps) => {
    let sliderColumns ;
    if(enabledFeatures.includes(Feature.DTAG_GENERAL)) {
        const cmsSliderColumns = cmsContent[CmsPageContentIdentifier.TileSliderColumns];
        sliderColumns= cmsSliderColumns === undefined ? defaultSliderColumns : cmsSliderColumns;
    } else {
        sliderColumns = defaultSliderColumns;
    }
    return slider
        ? <Slider config={`tile-slider-${sliderColumns}-columns`} isCmsCall={isCmsCall}>{children}</Slider>
        : (
            <ItemCollection columns={defaultSliderColumns} tablet wide>
                {React.Children.map(children, (child) => (
                    <div className="item" style={{paddingTop: '20px', display: 'flex'}}>
                        {child}
                    </div>
                ))}
            </ItemCollection>
        )
};

const mapStateToProps = (state: ReduxStateType) => ({
    cmsContent: state.cmsContent,
    enabledFeatures: state.enabledFeatures,
});

export default connect(mapStateToProps)(TariffCatalogWrapper);
